import React from 'react';
import { message } from 'antd';
import { AppliedFilter, FilterArrayItem } from '../types';

export interface SaveFilterSetLinkProps {
  appliedFilters: AppliedFilter[];
  filterArray: FilterArrayItem[];
  onOpen: () => void;
  isSaved: boolean;
}

const baseLinkStyle: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  marginLeft: 8,
  marginTop: 7,
  userSelect: 'none',
};

const activeLinkStyle: React.CSSProperties = {
  ...baseLinkStyle,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

const savedLinkStyle: React.CSSProperties = {
  ...baseLinkStyle,
  cursor: 'default',
  color: 'var(--gray-400)',
  whiteSpace: 'nowrap',
};

const SaveFilterSetLink: React.FC<SaveFilterSetLinkProps> = ({
  appliedFilters,
  filterArray,
  onOpen,
  isSaved,
}) => {
  const hasAnyFilters =
    (appliedFilters && appliedFilters.length > 0) ||
    (filterArray && filterArray.length > 0);

  if (!appliedFilters || appliedFilters.length === 0) {
    return null;
  }

  const handleClick: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    e.stopPropagation?.();

    if (isSaved) {
      return;
    }

    if (!hasAnyFilters) {
      message.info('No filters to save');
      return;
    }

    onOpen();
  };

  const label = isSaved ? 'Filter set saved' : 'Save filter set';

  return (
    <span
      style={isSaved ? savedLinkStyle : activeLinkStyle}
      onClick={handleClick}
    >
      {label}
    </span>
  );
};

export default SaveFilterSetLink;
